﻿import { useEffect } from 'react';

export function useClickOutside(
    containerRef: HTMLButtonElement | null,
    onClickOutside: () => void,
    dependencies: any[] = []
) {
    useEffect(() => {
        function handleClickOutside(event) {
            const isClickOutside = !(containerRef && containerRef.contains(event.target));
            if (isClickOutside) {
                onClickOutside();
            }
        }

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, dependencies);
}
